const ERROR_MAP = [
  {
    match: /401|403|unauthorized|invalid.*credential|incorrect.*password/i,
    message: 'Invalid username or password. Please check your credentials.',
  },
  {
    match: /network error|failed to fetch|timeout|econnrefused/i,
    message: 'Unable to reach the server. Check your connection and try again.',
  },
  {
    match: /oidc|identity provider|redirect.*failed/i,
    message: 'idAMan authentication could not be started. Please try again.',
  },
  {
    match: /500|502|503|server/i,
    message: 'The server encountered an error. Please try again shortly.',
  },
];

export const extractLoginError = error => {
  if (!error) return '';

  if (typeof error === 'string') return error;

  if (typeof error === 'object') {
    if (error.message && typeof error.message === 'string')
      return error.message;
    if (error.data) {
      if (typeof error.data === 'string') return error.data;
      if (error.data?.message) return error.data.message;
    }
  }

  return String(error);
};

export const formatLoginError = error => {
  const raw = extractLoginError(error).trim();
  if (!raw) return 'Something went wrong. Please try again.';

  const mapped = ERROR_MAP.find(({ match }) => match.test(raw));
  return mapped ? mapped.message : raw;
};
